'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 浏览器顶部设置
module.exports = {
	/**
  * @desc 设置WebViewTitle标题
  * @param {String} title 页面顶部显示的title
  */
	setWebViewTitle: function setWebViewTitle(title) {
		setTimeout(function () {
			_jockey2.default.send('SetWebViewTitle', {
				title: title
			});
		}, 500);
	},

	/**
  * @desc 设置左上角按钮样式
  * @param {All} param  接受所有类型参数
  *         String 类型: 左上角按钮显示文字为: param
  *         Boolean 类型: 左上角按钮显示文字是否显示,ture的话,默认文字是'返回'
  *         其他类型: 左上角按钮显示文字为'返回'
  */
	setLeftBar: function setLeftBar(param) {
		var data = {
			title: '返回',
			show: 1
		};
		if (typeof param === 'boolean') {
			data.show = param ? 1 : 0;
		} else if (typeof param === 'string') {
			data.title = param;
		} else if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'object') {
			param.show = param.show ? 1 : 0;
			data = param;
		}
		_jockey2.default.send("SetLeftBar", data);
	},

	/**
  * @desc 返回按钮事件
  * @param {Function} cb 不传表示取消原来的返回绑定事件
  */
	setLeftBarEvent: function setLeftBarEvent(cb) {
		if (cb) {
			// 大风车安卓需要先执行一下 JockeyExistBridge Jockey
			_jockey2.default.send('JockeyExistBridge');
			_jockey2.default.off('GoBackEvent');
			_jockey2.default.on('GoBackEvent', function (payload, complete) {
				if (complete) {
					complete({
						goback: 0
					});
					cb();
				}
			});
		} else {
			_jockey2.default.off('GoBackEvent');
		}
	},

	/**
  * @desc 设置关闭按钮样式
  * @param {Boolean} show  是否显示关闭按钮
  */
	setCloseBar: function setCloseBar(params) {
		var data = {
			title: '关闭',
			show: true
		};
		if (typeof params === 'string') {
			data.title = params;
		} else if (typeof params === 'boolean') {
			data.show = params;
		} else if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
			data = params;
		} else {
			data.show = false;
		}
		data.show = data.show ? 1 : 0;
		_jockey2.default.send("SetCloseBar", data);
	},

	/**
  * @desc 设置右边第二个按钮
  * @param {String} content  按钮显示文字
  * @param {Function} cb  不传表示取消原来的绑定事件
  */
	setRightSubBar: function setRightSubBar(content, cb) {
		_jockey2.default.send("SetRightSubBar", {
			title: content,
			show: content ? 1 : 0
		});
		if (cb === 'none') {
			return;
		}
		if (cb) {
			// 大风车安卓需要先执行一下 JockeyExistBridge Jockey
			_jockey2.default.off('RightSubBarEvent');
			_jockey2.default.on('RightSubBarEvent', function (payload, complete) {
				if (complete) {
					complete({
						native: 0
					});
					cb();
				}
			});
		} else {
			_jockey2.default.off('RightSubBarEvent');
		}
	},

	/**
  * @desc 设置右上角按钮
  * @param {String} params  第二个按钮显示文字
  * @param {Function} cb  不传表示取消原来的绑定事件
  */
	setRightBar: function setRightBar(params, cb) {
		if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
			params.show = params.show ? 1 : 0;
			_jockey2.default.send("SetRightBar", params);
		} else {
			_jockey2.default.send("SetRightBar", {
				title: params,
				show: params ? 1 : 0
			});
		}
		if (cb === 'none') {
			return;
		}
		if (cb) {
			_jockey2.default.off('RightBarEvent');
			// 大风车安卓需要先执行一下 JockeyExistBridge Jockey
			_jockey2.default.on('RightBarEvent', function (payload, complete) {
				if (complete) {
					complete({
						native: 0
					});
					cb();
				}
			});
		} else {
			_jockey2.default.off('RightBarEvent');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/webview-title.js
// module id = 273
// module chunks = 4